<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                size="sm"></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header" style="margin-bottom: 1px;">
          <transition name="animation" mode="out-in">
            <div v-if="items && items.length > 0" key="cards" style="padding: 2px">
              <div class="sa-ft-card-list" v-show="initComponent">
                <div v-for="(item, index) in items" :key="item.nre || index">

                  <section class="sa-ft-section-container">
                    <div class="sa-ft-form-card">
                      <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">👤</div>
                        <h3>{{ item.patient.name }}
                          <h3 class="cursive">{{ item.patient.code }}</h3>
                        </h3>
                        <div style="display: table; margin-left: auto; text-align: center;">
                          <label class="sa-ft-label">NRE</label>
                          <h3 style="font-size: medium;"> {{ item.prescription.nre }}</h3>
                        </div>
                        <div style="display: table; margin-left: auto; text-align: right;">
                          <button type="button" @click="onClickPrendiInCarico(item)" class="sa-ft-action-btn primary">
                            <span>Prendi In Carico</span>
                            <small>💡</small>
                          </button>
                        </div>
                      </div>
                      <div class="sa-ft-grid">
                        <!-- <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">✍🏻</div>
                            <div class="sa-ft-inner-row">
                              <div class="sa-ft-inner-column flex-main">
                                <label class="sa-ft-form-label">Prescrizione</label>
                                <span class="sa-ft-value">{{ item.patient.name }}</span>
                              </div>
                            </div>
                          </div> -->
                        <div class="sa-ft-field flex-1">
                          <div class="sa-ft-icon-box">👤</div>
                          <div class="sa-ft-data">
                            <label class="sa-ft-label">Nominativo</label>
                            <span class="sa-ft-value">{{ item.patient.name }}</span>
                          </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                          <div class="sa-ft-icon-box">👤</div>
                          <div class="sa-ft-data">
                            <label class="sa-ft-label">Data Ingresso</label>
                            <span class="sa-ft-value"> {{ formatIso(item.prescription.entryDatetime) }}</span>
                          </div>
                        </div>

                      </div>
                      <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">✍🏻</div>
                        <h3>Prescrizione</h3>
                        <div style="display: table; margin-left: auto; text-align: right;">
                          <label class="sa-ft-label">Priorità</label>
                          <div style="display: table; margin-left: auto; text-align: right;">
                            <span class="sa-ft-circle-wrapper-orange">{{ item.prescription.priorityClass.id }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                          <div class="sa-ft-icon-box">📅</div>
                          <div class="sa-ft-data">
                            <label class="sa-ft-label">Data Prescrizione</label>
                            <span class="sa-ft-value">{{ formatIso(item.prescription.compilationDatetime) }}</span>
                          </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                          <div class="sa-ft-icon-box">🚻</div>
                          <div class="sa-ft-data">
                            <label class="sa-ft-label">Tipo</label>
                            <span class="sa-ft-value"> {{ item.prescription.prescriptionType.name }}</span>
                          </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                          <div class="sa-ft-icon-box">🚻</div>
                          <div class="sa-ft-data">
                            <label class="sa-ft-label">Esenzione</label>
                            <span class="sa-ft-value"> {{ item.prescription.exemption.name }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="sa-ft-card-header" v-b-toggle="'collapse-gruppo-' + index">
                        <div class="sa-ft-section-icon">🚀</div>
                        <h3>Prestazioni</h3>
                        <div style="display: table; margin-left: auto; text-align: right;">
                          <span class="sa-ft-circle-wrapper"> {{ item.details.length }}</span>

                        </div>
                        <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                          :class="{ 'is-open': item.isOpen }">▼</span>
                      </div>
                      <b-collapse @show="gestisciApertura(item, index)" @hide="gestisciChiusura(item, index)"
                        :id="'collapse-gruppo-' + index">
                        <div class="sa-ft-modern-cards-wrapper">
                          <ul>
                            <li style="width: 100% !important; padding: 5px;"
                              v-for="(prestazione, index) of item.details" :key="index">
                              <div class="sa-ft-modern-card sa-ft-modern-card-default">
                                <div class="sa-ft-grid">
                                  <div class="sa-ft-field-normal flex-auto">
                                    <div class="sa-ft-data">
                                      <span class="sa-ft-data-value" style="font-size: 2.0rem; line-height: 1;">⚡</span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-main">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Prestazione</label>
                                      <span class="sa-ft-data-value">{{ prestazione.service.name }}</span>
                                      <span class="sa-ft-data-value-sub cursive">{{ prestazione.service.code
                                      }}</span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-2 text-center">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Branca</label>
                                      <span class="sa-ft-data-value">
                                        <span class="sa-ft-badge primary">
                                          <span class="sa-ft-data-value">{{ prestazione.specialization.name
                                          }}</span>

                                        </span>
                                        <small>{{ prestazione.executionUnit.name
                                        }}</small>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-2 text-center">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Struttura</label>
                                      <span class="sa-ft-data-value">
                                        <span class="sa-ft-badge primary">
                                          <span class="sa-ft-data-value">{{ prestazione.site.name
                                          }}</span>
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-1 text-center">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Stato</label>
                                      <span class="sa-ft-data-value">
                                        <span class="sa-ft-badge primary">
                                          {{ prestazione.status.name.toUpperCase() }}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-auto text-center">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Quantita</label>
                                      <span class="sa-ft-data-value">
                                        <span class="sa-ft-badge primary">
                                          {{ prestazione.quantity }}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-auto text-center">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Tariffa</label>
                                      <span class="sa-ft-data-value">
                                        <span class="sa-ft-badge primary">
                                          {{ formatEuro(prestazione.price) }}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="sa-ft-field-normal flex-1 text-center">
                                    <div class="sa-ft-data">
                                      <label class="sa-ft-data-label">Appuntamento</label>
                                      <span class="sa-ft-data-value" v-if="prestazione.booking">
                                        <div class="sa-ft-value-combine-wrapper">

                                          <div class="sa-ft-value-combine">
                                            <div class="sa-ft-value-combine-row">
                                              <span class="sa-ft-value-combine-label">I:</span>
                                              <span class="sa-ft-value-combine-value">
                                                {{ formatDateIso(prestazione.executionDatetime) }}
                                                {{ formatTime(prestazione.booking.startTime)
                                                }}</span>
                                            </div>
                                            <div class="sa-ft-value-combine-row">
                                              <span class="sa-ft-value-combine-label">F:</span>
                                              <span class="sa-ft-value-combine-value">
                                                {{ formatDateIso(prestazione.executionDatetime) }}
                                                {{
                                                  formatTime(prestazione.booking.endTime)
                                                }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </span>

                                      <!--  <div class="sa-ft-field-normal flex-1 text-end">
                                        <div class="sa-ft-data">
                                            <div style="gap: 8px;"
                                                class="d-flex justify-content-md-end justify-content-between">
                                               <b-button v-b-tooltip.hover size="sm" variant="outline-primary"
                                                    title="Gestisci Ricetta"
                                                    class="rounded-circle sa-ft-floating-btn secondary">
                                                    <b-icon icon="clipboard"></b-icon>
                                                </b-button> 

                                            </div>
                                        </div>-->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </b-collapse>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <NoDataComponent v-else ref="cmpNoDataComponent"
              title="Non sono presenti prenotazioni per la data riferimento" nome="no-data" subtitle=""
              icon="fas fa-users" />
          </transition>
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
              size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <!--  -->
      <b-modal ref="mdlOkAnagraficaDatiPresaInCarico" @shown="onShownModalIntegrazione" size="xl" no-close-on-backdrop
        no-close-on-esc hide-header-close>
        <div>

          <div class="sa-ft-card-header" v-if="!jsonDataIntegrazione.patientExist">
            <div class="sa-ft-section-icon">⚠️</div>
            <label class="sa-ft-label"> Prevista Registrazione Paziente</label>
          </div>
          <div class="sa-ft-card-header" v-else>
            <div class="sa-ft-section-icon">✅</div>
            <label class="sa-ft-label"> Paziente già registrato in piattaforma</label>
          </div>

          <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill @input="onInputTabs">
            <b-tab style="height: 500px !important; width: 100%; overflow-y: scroll;" title="Dati Anagrafici" active>
              <AccettazioneSsnAnagraficaComponentN @changeJsonData="onChangeJsonData"
                :initJsonData="jsonDataIntegrazione" ref="cmpAccettazioneSsnAnagraficaComponentN" :isEdit="true" />
            </b-tab>
            <b-tab style="height: 500px !important; width: 100%; overflow-y: scroll;" title="Impegnativa">
              <div v-for="(ricetta, index) in jsonDataIntegrazione.ricette" :key="index">
                <section class="sa-ft-section-container">
                  <div class="sa-ft-form-card">
                    <div class="sa-ft-card-header">
                      <div class="sa-ft-section-icon">🚀</div>
                      <h3>Ricetta</h3>
                      <div style="display: table; margin-left: auto; text-align: right;">
                        <label class="sa-ft-label">Priorità</label>
                        <div style="display: table; margin-left: auto; text-align: right;">
                          <div class="sa-ft-circle-wrapper-orange">{{ ricetta.classePriorita }} </div>
                        </div>
                      </div>
                    </div>
                    <div class="sa-ft-grid">
                      <div class="sa-ft-field flex-1">
                        <div class="sa-ft-icon-box">🏷️</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Tipologia Ricetta</label>
                          <span class="sa-ft-value">{{ ricetta.tipologiaRicetta }}</span>
                        </div>
                      </div>
                      <div class="sa-ft-field flex-1">
                        <div class="sa-ft-icon-box">𝄃𝄃𝄂𝄀𝄁𝄃𝄂𝄂𝄃</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">NRE</label>
                          <span class="sa-ft-value">{{ ricetta.codiceBar1 }} {{ ricetta.codiceBar2 }}</span>
                        </div>
                      </div>
                      <div class="sa-ft-field flex-1">
                        <div class="sa-ft-icon-box">👤</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Codice Fiscale Assistito</label>
                          <span class="sa-ft-value">{{ ricetta.codiceFiscaleAssistito }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="sa-ft-grid">
                      <div class="sa-ft-field flex-3">
                        <div class="sa-ft-icon-box">📅</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Data Prescrizione</label>
                          <span class="sa-ft-value">{{ formatDateTime(ricetta.dataPrescrizione) }}</span>
                        </div>
                      </div>
                      <div class="sa-ft-field flex-auto">
                        <div class="sa-ft-icon-box">📋</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Esenzione</label>
                          <span class="sa-ft-value">{{ ricetta.codiceEsenzione }}</span>
                        </div>
                      </div>
                      <div class="sa-ft-field flex-auto">
                        <div class="sa-ft-icon-box">📋</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Non Esente</label>
                          <span class="sa-ft-value" v-if="ricetta.nonEsente">✅</span>
                          <span class="sa-ft-value" v-else>❌</span>
                        </div>
                      </div>
                      <div class="sa-ft-field flex-auto">
                        <div class="sa-ft-icon-box">📋💰</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Esenzione Reddito</label>
                          <span class="sa-ft-value" v-if="ricetta.esenteReddito">✅</span>
                          <span class="sa-ft-value" v-else>❌</span>
                        </div>
                      </div>
                    </div>
                    <div class="sa-ft-grid">
                      <div class="sa-ft-field flex-1">
                        <div class="sa-ft-icon-box">🩺</div>
                        <div class="sa-ft-data">
                          <label class="sa-ft-label">Medico Prescrittore</label>
                          <span class="sa-ft-value">{{ ricetta.presCognome }} {{ ricetta.presNome }} {{
                            ricetta.matricola
                          }}</span>
                        </div>
                      </div>


                    </div>
                    <div class="sa-ft-card-header" v-b-toggle="'collapse-prestazioni'">
                      <div class="sa-ft-section-icon">🚀</div>
                      <h3>Prestazioni</h3>
                      <div style="display: table; margin-left: auto; text-align: right;">
                        <span class="sa-ft-circle-wrapper"> {{ ricetta.prestazioni.length }}</span>

                      </div>
                      <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange" :class="{ 'is-open': isOpen }">▼</span>
                    </div>
                    <b-collapse @show="gestisciApertura()" @hide="gestisciChiusura()" :id="'collapse-prestazioni'">
                      <div class="sa-ft-modern-cards-wrapper" v-for="(prestazione, index) of ricetta.prestazioni"
                        :key="index">
                        <li style="width: 100% !important; padding: 5px;">
                          <div class="sa-ft-modern-card sa-ft-modern-card-default">
                            <div class="sa-ft-grid">
                              <div class="sa-ft-field-normal flex-auto">
                                <div class="sa-ft-data">
                                  <span class="sa-ft-data-value" style="font-size: 2.0rem; line-height: 1;">⚡</span>
                                </div>
                              </div>
                              <div class="sa-ft-field-normal flex-main">
                                <div class="sa-ft-data">
                                  <label class="sa-ft-data-label">Prestazione</label>
                                  <span class="sa-ft-data-value">{{ prestazione.descrizionePrestazione }}</span>
                                  <span class="sa-ft-data-value-sub cursive">{{ prestazione.codicePrestazione
                                  }}</span>
                                </div>
                              </div>
                              <div class="sa-ft-field-normal flex-2 text-center">
                                <div class="sa-ft-data">
                                  <label class="sa-ft-data-label">Branca</label>
                                  <span class="sa-ft-data-value">
                                    <span class="sa-ft-badge primary">
                                      <span class="sa-ft-data-value">{{ prestazione.specialization
                                      }}</span>
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <div class="sa-ft-field-normal flex-1 text-center">
                                <div class="sa-ft-data">
                                  <label class="sa-ft-data-label">Stato</label>
                                  <span class="sa-ft-data-value">
                                    <span class="sa-ft-badge primary">
                                      {{ prestazione.statoAttuale.toUpperCase() }}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <div class="sa-ft-field-normal flex-auto text-center">
                                <div class="sa-ft-data">
                                  <label class="sa-ft-data-label">Quantita</label>
                                  <span class="sa-ft-data-value">
                                    <span class="sa-ft-badge primary">
                                      {{ prestazione.quantita }}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <div class="sa-ft-field-normal flex-auto text-center">
                                <div class="sa-ft-data">
                                  <label class="sa-ft-data-label">Tariffa</label>
                                  <span class="sa-ft-data-value">
                                    <span class="sa-ft-badge primary">
                                      {{ formatEuro(prestazione.prezzo) }}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <!-- <div class="sa-ft-field-normal flex-1 text-center">
                              <div class="sa-ft-data">
                                <label class="sa-ft-data-label">Appuntamento</label>
                                <span class="sa-ft-data-value" v-if="prestazione.booking">
                                  <div class="sa-ft-value-combine-wrapper">

                                    <div class="sa-ft-value-combine">
                                      <div class="sa-ft-value-combine-row">
                                        <span class="sa-ft-value-combine-label">Inizio:</span>
                                        <span class="sa-ft-value-combine-value">
                                          {{ formatDateIso(prestazione.executionDatetime) }}
                                          {{ formatTime(prestazione.booking.startTime)
                                          }}</span>
                                      </div>
                                      <div class="sa-ft-value-combine-row">
                                        <span class="sa-ft-value-combine-label">Fine:</span>
                                        <span class="sa-ft-value-combine-value">
                                          {{ formatDateIso(prestazione.executionDatetime) }}
                                          {{
                                            formatTime(prestazione.booking.endTime)
                                          }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </div>
                            </div> -->
                            </div>
                          </div>
                        </li>
                      </div>
                    </b-collapse>
                  </div>
                </section>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <template #modal-footer>
          <div class="w-100">
            <p class="float-left">Conferma per Dati Anagrafici e Prestazioni</p>
            <b-button variant="primary" size="sm" class="float-right ml-3" @click="onConfermaDatiIntegrazione">
              👉 Conferma Dati Paziente
            </b-button>
            <b-button variant="primary" size="sm" class="float-right" @click="onAnnullaIntegrazione">
              ❌ Annulla
            </b-button>

          </div>
        </template>
      </b-modal>

      <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
//import PrintComponent from "../../../utility/components/PrintComponent.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast";
import axios from 'axios';
import AccettazioneSsnAnagraficaComponentN from "./AccettazioneSsnAnagraficaComponentN.vue";
// import toast from "../../../../template/layout/utility/sa-toast";
export default {
  //PrintComponent
  mixins: [UtilityMixin],
  components: { PdfPrintViewEmbedded, NoDataComponent, AccettazioneSsnAnagraficaComponentN },
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  data() {
    return {
      initComponent: false,
      pathResource: "/saccsarr/appuntamenti/",
      items: [],
      rows: 0,
      filtro: {
        cfPaziente: null,
        startTime: new Date().getTime(),
        endTime: new Date().getTime(),
      },
      isOpen: false,
      page: 1,
      jsonDataIntegrazione: {},
      presidio: {},
      accettazione: {},
      perPage: 20,
      signedPdfViewer: null,
      previewSelected: null,
      currentPage: 1,
      rowSelectedAccettazione: {},
      listaRicetteDetails: {},
      idStruttura: null,
      patientExist: false
    };
  },

  mounted() {

    //me.init();
    this.getPresidio();
    console.log(this.presidio);
    if (this.presidio) {
      this.idStruttura = this.presidio.codiceStruttura;
    }

  },
  methods: {
    init() {
      let me = this;
      this.patientExist = false
      me.loadData();
    },
    formatEuro(value) {
      if (value === null || value === undefined || isNaN(value)) return '€ 0,00';

      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    },
    getPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },
    gestisciApertura(item, index) {
      if (item) {
        this.$set(item, 'isOpen', true);
        console.log(`Gruppo ${index} aperto`);
      }
      this.isOpen = true;
    },
    gestisciChiusura(item, index) {
      if (item) {
        this.$set(item, 'isOpen', false);
        console.log(`Gruppo ${index} chiuso`);
      }
      this.isOpen = false;
    },
    onShownModalIntegrazione() {

    },
    onChangeJsonData(json) {
      this.jsonDataIntegrazione = JSON.parse(JSON.stringify(json));
      this.jsonDataIntegrazione.accettazioneAnagrafica = this.jsonDataIntegrazione.accettazione.accettazioneAnagrafica;
    },
    onAnnullaIntegrazione() {
      this.jsonDataIntegrazione = {};
      this.isOpen = false;
      this.closeModalConfermaPresaInCarico();

    },
    formatTime(dateString) {
      if (!dateString) return "";

      // Rimuove la Z finale per forzare JavaScript a leggerla come ora locale
      const localString = dateString.replace("Z", "");
      const date = new Date(localString);

      // Estrai ore e minuti normalmente
      const ore = String(date.getHours()).padStart(2, '0');
      const minuti = String(date.getMinutes()).padStart(2, '0');

      return `${ore}:${minuti}`; // Restituirà "15:00"
    },

    onConfermaDatiIntegrazione() {
      this.openShowModalLoading()
      let link = process.env.VUE_APP_PATH_API + "/accettazionessn";
      console.log(this.jsonDataIntegrazione);
      delete this.jsonDataIntegrazione.integrationAccettazione;
      delete this.jsonDataIntegrazione.accettazionePrestazioni;

      axios.post(link, this.jsonDataIntegrazione).then((response) => {
        let idPaziente = response.data.data.id;

        this.$router.push("/rsapaziente/view/" + idPaziente)

        this.closeShowModalLoading();
      }).catch((err) => {
        this.closeShowModalLoading();
        console.log(err);

        toast.error(err)
      });
    },



    showModalConfermaPresaInCarico() {
      this.$refs.mdlOkAnagraficaDatiPresaInCarico.show();
    },
    closeModalConfermaPresaInCarico() {
      this.$refs.mdlOkAnagraficaDatiPresaInCarico.hide();
    },
    onInputTabs(i) {
      console.log(i);

    },


    getClass(sezione, valore) {

      switch (sezione) {
        case 'stato':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        case 'gruppo':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        case 'card':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        default:
          break;
      }
    },

    getOra(date) {
      return moment(date).format("HH:mm");
    },
    getFormatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },
    onClickSchedaPaziente(item) {
      this.$router.push("/accettazionessn/schedapaziente/" + item.id)
    },


    loadData() {
      let me = this;
      this.openShowModalLoading();
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPagePrenotazioniLazio");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      this.$emit("updateFilter", me.filtro)
      this.initComponent = true;

      this.loadDataResources(me.pathResource + "/" + this.idStruttura, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      if (response.data.data) {

        me.items = response.data.data.content;
        me.rows = response.data.data.content.length;
        toast.success("Prenotazioni Cariche con successo")
      } else {
        toast.warning("Non ci sono prenotazioni per la data corrente")
      }
      this.closeShowModalLoading();
      me.$emit("afterLoadData");
    },
    loadDataAccettazioneSsnError(error) {

      toast.error("Errore con Recup");
      console.log(error);
      if (error?.respose?.data?._messages) {
        console.log(error.data._messages);

      }


      this.closeShowModalLoading();
    },
    onClickPrendiInCarico(item) {
      this.openShowModalLoading();
      this.prendiInCarico(item.id);


    },
    prendiInCarico(id) {
      let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazione/" + this.idStruttura + "?idPrenotazione=" + id;
      axios.get(link).then((response) => {
        console.log(response);
        this.closeShowModalLoading();
        this.showModalConfermaPresaInCarico();
        this.jsonDataIntegrazione = response.data.data;
      }).catch((erro) => {
        console.log(erro);

        toast.error(erro.response.data.messaggio)
        this.closeShowModalLoading();

      });

    }

  },
  watch: {
    currentPage() {
      let me = this;
      me.loadData();
    },
  },
};
</script>

<style scoped>
.sa-ft-form-card {
  padding: 15px !important;
}


.animation-enter-active,
.animation-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animation-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.animation-enter-to {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

.sa-ft-arrow-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 0.8rem;
  /* Regola la dimensione a piacimento */
  color: #6c757d;
  /* Colore grigio neutro, personalizzabile */
}

/* Quando il pannello è aperto, ruota la freccia verso l'alto */
.sa-ft-arrow-icon.is-open {
  transform: rotate(180deg);
}

.animation-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.sa-ft-value-combine-wrapper {
  font-family: 'Segoe UI', Roboto, sans-serif;
  border-radius: 8px;
  max-width: 200px;
}

.sa-ft-value-combine {
  margin-top: 8px;
  padding-left: 5px;
}

.sa-ft-value-combine-row {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 4px;
}

.sa-ft-circle-wrapper {
  /* Dimensioni e Forma */
  width: 30px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;

  /* Centratura del numero */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estetica */
  background-color: #007bff21;
  color: rgba(0, 47, 255, 0.712);
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;

  /* Opzionale: bordino o ombra */
  border: 2px solid #0056b3;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-circle-wrapper-orange {
  /* Dimensioni e Forma */
  width: 30px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;

  /* Centratura del numero */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estetica */
  background-color: #ff660021;
  color: rgba(233, 71, 22, 0.801);
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;

  /* Opzionale: bordino o ombra */
  border: 2px solid #b34800;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-value-combine-label {
  font-size: 0.98rem;
  color: #6c757d;
  font-weight: 600;
  width: 40px;
}

.sa-ft-value-combine-value {
  font-size: 0.80rem;
  color: #212529;
  font-weight: 700;
}
</style>
